import React, { ReactNode } from 'react';

import { TableCell, TableHeader } from '~/components/table';

import * as S from './CustomComponents.styles';

export const CustomLink = ({
  href,
  children,
  title,
}: {
  href?: string;
  children?: ReactNode;
  title?: string;
}) => (
  <S.MarkdownA
    href={href}
    title={title}
    target="_blank"
    rel="noopener noreferrer"
  >
    {children}
  </S.MarkdownA>
);

export const CustomTableCell = ({ children }: { children?: ReactNode }) => (
  <TableCell>{children}</TableCell>
);

export const CustomTableHeader = ({ children }: { children?: ReactNode }) => (
  <TableHeader>{children}</TableHeader>
);

export const CustomTable = ({ children }: { children?: ReactNode }) => (
  <S.MarkdownTableContainer>
    <S.MarkdownTable>{children}</S.MarkdownTable>
  </S.MarkdownTableContainer>
);
